<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card>
      <div class="px-0">

        <v-card-title class="headline pl-4 py-2 pr-2">
          Nie można nadać uprawnień.
          <v-spacer></v-spacer>
          <v-btn
            @click.native="visibility = false"
            icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-4 mt-4">
          Dostęp można nadać tylko dla katalogów.
        </v-card-text>

        <v-card-actions class="px-4 py-4">
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            @click.native="visibility = false"
          >
            Rozumiem
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'permissions-alert-dialog',
  computed: {
    ...mapGetters('files', [
      'dialogVisibility',
    ]),
    visibility: {
      get() {
        return this.dialogVisibility.type === 'permissions-alert';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('files', [
      'setDialogVisbility',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
  },
};
</script>
